import { computed, Ref } from "@vue/composition-api";
import { ContentFile } from "@scrile/api-provider/dist/api/ContentFilesProvider";
import { FileData } from "@scrile/api-provider/dist/api/FileProvider";
import { isVideoFile } from "@/lib/fileHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { CONTENT_FEED_GRID_ITEM_WIDTH } from "@/const";

export default function useCoverThumbnail(
  coverFile: Ref<ContentFile | FileData | null | undefined>,
  containerWidth: number = CONTENT_FEED_GRID_ITEM_WIDTH
) {
  const isPortrait = computed(() => {
    if (coverFile.value) {
      return "fileId" in coverFile.value
        ? coverFile.value.metadata.height > coverFile.value.metadata.width
        : coverFile.value.height > coverFile.value.width;
    }
    return false;
  });
  const thumbnailWidth = computed(() => containerWidth * Math.floor(window.devicePixelRatio));
  const method = computed(
    () => (coverFile.value && isVideoFile(coverFile.value) && "getVideoThumbnail") || "getImageThumbnail"
  );

  const coverSrc = computed(() => {
    if (!!coverFile.value) {
      return MediaFilesController[method.value](
        coverFile.value.urlPart,
        isPortrait.value ? thumbnailWidth.value : "auto",
        !isPortrait.value ? thumbnailWidth.value : "auto",
        {
          exactSize: true,
        }
      );
    }
    return "";
  });

  return { coverSrc };
}
